// https://developer.mozilla.org/en-US/docs/Web/API/DOMParser
// http://domparsing.spec.whatwg.org
// https://gist.github.com/1129031
// Require a browser that support DOMParser
(function() {
	var prototype = DOMParser.prototype;
	var parseFromStringNative = prototype.parseFromString;

	// Firefox/Opera/IE throw errors on unsupported types
	try {
		var parser = new DOMParser();
		// WebKit returns null on unsupported types
		if (parser.parseFromString("", "text/html") && parser.parseFromString("", "image/svg+xml")) {
			// text/html parsing is natively supported
			return;
		}
	} catch (ex) {}

	prototype.parseFromString = function parseFromString(markup, type) {
		// HTML or SVG
		if (/^\s*(?:text\/html|application\/xhtml\+xml|image\/svg\+xml)\s*(?:;|$)/i.test(type)) {
			var document = document.implementation.createHTMLDocument("");
			document.documentElement.innerHTML = markup;
			return document;
		} else {
			return parseFromStringNative.apply(this, arguments);
		}
	};
})();